var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import resources from '../../resources';
import * as authActions from '../actions/auth';
var initialState = {
  loggedIn: false,
  token: null,
  facilityUser: null,
  redirectUrl: '/'
};
export default function (state, action) {
  if (state === void 0) {
    state = initialState;
  }
  switch (action.type) {
    case authActions.AUTH_TOKEN_LOADING:
      return __assign(__assign({}, state), {
        loggedIn: false,
        token: null,
        facilityUser: null
      });
    case authActions.AUTH_TOKEN_LOAD_FAILED:
      return __assign(__assign({}, state), {
        loggedIn: false,
        token: null,
        facilityUser: null
      });
    case authActions.AUTH_TOKEN_LOAD_SUCCESS:
      resources.setToken(action.accessToken);
      return __assign(__assign({}, state), {
        loggedIn: true,
        token: __assign(__assign({}, action.accessToken), {
          client: undefined
        }),
        facilityUser: action.accessToken.data.facilityUser
      });
    case authActions.LOGOUT:
      return __assign(__assign({}, state), {
        loggedIn: false,
        token: null,
        facilityUser: null,
        redirectUrl: action.redirectUrl
      });
    case 'persist/REHYDRATE':
      // Set authorization token if available
      if (action && action.payload && action.payload.auth && action.payload.auth.token) {
        resources.setToken(action.payload.auth.token);
      }
  }
  return state;
}